module.exports = __webpack_public_path__ + "img/live-scene.c6391ce5.png";